var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'fixed',
    'top-0',
    'bottom-0',
    'right-0',
    'left-0',
    'pointer-events-none',
    'inline-flex',
    'items-end',
    'flex-row-reverse',
    'space-x-reverse',
    'space-x-4',
    'z-backdrop',
    'pl-8',
    'pr-[6.5rem]',
    _vm.isPageHandlingDragEvent && 'bg-grape-500 dark:bg-drag-overlay-dark bg-opacity-50 dark:bg-opacity-35' ]},[(_vm.draftCids.length > 1)?_c('div',{staticClass:"flex-shrink-0 pointer-events-auto"},[_c('OzBaseButton',{ref:"bulkActionButton",class:[
        'h-10',
        'w-10',
        'p-0',
        'grid',
        'place-items-center',
        'rounded-t-xl',
        'bg-light-ui-100',
        'dark:bg-dark-ui-100',
        'text-dark-text-200 dark:text-light-text-200',
        'hover-hover:hover:text-dark-text-100 hover-hover:dark:hover:text-light-text-100',
        'focus:text-grape-500 dark:focus:text-canary-500',
        'active:text-grape-500 dark:active:text-canary-500',
        _vm.isUsingNewSurfaceShadows && 'shadow-elevation-2' ],on:{"click":_vm.openBulkActionMenu}},[_c('OzIcon',{attrs:{"name":"bulk_action","size":24}})],1),_vm._v(" "),(_vm.xBulkActionMenu)?_c('SurfaceDraftBulkActionPopover',{attrs:{"popover-anchor":_vm.bulkActionPopoverAnchor},on:{"cancel":_vm.closeBulkActionMenu,"publish-all":_vm.publishAllDrafts,"delete-all":_vm.deleteAllDrafts}}):_vm._e()],1):_vm._e(),_vm._v(" "),_vm._l((_vm.draftCids),function(draftCid){return _c('surface-composer-modal-new',{key:draftCid,style:(_vm.hideMarginStyle(draftCid)),attrs:{"draft-cid":draftCid,"file":_vm.uploadingFileByCid(draftCid),"max-file-size":_vm.maxFileUploadSizeByCid(draftCid)},on:{"error":function (file, message) { return _vm.onUploadError(file, message, draftCid); },"cancel":function (file) { return _vm.onUploadCancel(file, draftCid); },"done":function (file, url) { return _vm.onUploadDone(file, url, draftCid); },"reject":function (file, reason) { return _vm.onUploadReject(file, reason, draftCid); }}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }